import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	maxReached: {
		id: 'servicedesk-sla-settings.metrics.metric.editable.form.goals.limit.max-reached',
		defaultMessage:
			"You've reached the limit of {goalsLimit} SLA {goalsLimit, plural, one {goal} other {goals}} in this project.",
		description: 'inline message displayed when maximum goals are consumed',
	},
	aboutToReachMaxLimit: {
		id: 'servicedesk-sla-settings.metrics.metric.editable.form.goals.limit.about-to-reach-max-limit',
		defaultMessage:
			'You can create {remaining} more SLA {remaining, plural, one {goal} other {goals}} in this project.',
		description: 'inline message displayed when maximum goals are consumed',
	},
	totalLimit: {
		id: 'servicedesk-sla-settings.metrics.metric.editable.form.goals.limit.total-limit',
		defaultMessage:
			"There's a limit of {goalsLimit} SLA {goalsLimit, plural, one {goal} other {goals}} in this project.",
		description: 'message displayed with goals limit',
	},
	tipForCreatingNewGoals: {
		id: 'servicedesk-sla-settings.metrics.metric.editable.form.goals.limit.tip-for-creating-new-goals',
		defaultMessage: 'You can delete some, or {tagStart}contact Atlassian Support{tagEnd} for more.',
		description: 'tip displayed for creating new goals',
	},
});
